export default __webpack_public_path__ + "static/media/blog-seach-btn.b58e67dd.svg";